import { render, staticRenderFns } from "./prepareInfoModal.vue?vue&type=template&id=64205d88&scoped=true&"
import script from "./prepareInfoModal.vue?vue&type=script&lang=js&"
export * from "./prepareInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64205d88",
  null
  
)

export default component.exports